<template>
  <div class="">
    <v-select
      v-model="supplierList"
      :options="supplierOptions"
      :clearable="false"
      @input="onChange"
      @search="onSearch"
      :disabled="isSelectDisabled"
    />
  </div>
</template>

<script>
import { ref, onMounted, computed, watch } from "@vue/composition-api";
import { BSpinner } from 'bootstrap-vue'
import vSelect from "vue-select";
import {debounce} from "lodash";
import axios from "@axios";

export default {
  components: {
    BSpinner,
    vSelect
  },
  props: {
    fieldOptions: Object,
    context: Object
  },
  setup(props, { emit }) {
    const search = ref("");
    const limit = ref(8);
    const supplierList = ref(false);
    const options = ref(null);
    const isSelectDisabled = ref(false);
    const supplierOptions = computed(() =>
      (options.value || []).map(u => ({
        value: u.id,
        label: u.name,
      }))
    );

    onMounted(() => {
      isSelectDisabled.value = props.context.attributes.disabled ?? false;
      supplierList.value = props.context.model
      fetchData()
    });

    watch(
      () => props.context.attributes.disabled,
      (newValue, oldValue) => {
        isSelectDisabled.value = props.context.attributes.disabled ?? false;
      },
      { immediate: true }
    );

    watch(
      () => props.context.model,
      (newValue, oldValue) => {
        if(newValue) {
          supplierList.value = newValue
        }
      },
      { immediate: true }
    );

    async function fetchData() {
      try {
        const {data} = await axios.get("/v1/companies", {
          params: {
            q: search.value,
            max: limit.value,
            sortBy: 'id',
          },
        });
        options.value = data.data;
      } catch (error) {
        console.error(`Supplier: request error`, error?.response || error);
      }
    }

    async function onChange(value) {
      props.context.model = value
    }


    const onSearch = debounce(async (query, loading) => {
      if (query && query.length) {
        loading(true);
        search.value = query;
        await fetchData();
        loading(false);
      } else {
        search.value = '';
        await fetchData();
      }
    }, 500);

    return {
      supplierList,
      supplierOptions,
      isSelectDisabled,
      onSearch,
      onChange
    }
  }
}
</script>